import {
  FETCH_CAMPAIGNS,
  CLEAR_CAMPAIGNS_STATE,
  CREATE_CAMPAIGN,
  EDIT_CAMPAIGN,
  // ADD_INSIGHT_TO_CAMPAIGN,
  CLEAR_CAMPAIGN_INSIGHTS,
  // ADD_INSIGHT_TO_ADSET,
  CLEAR_ADSETS_INSIGHTS,
  // ADD_INSIGHT_TO_AD,
  CLEAR_ADS_INSIGHTS,
  DELETE_CAMPAIGN
} from './mutations-types'
import moment from 'moment'
import store from '../../store'
import helpers from '../../../helpers/functions'
import lodash from 'lodash'
import Campaigns from '../../../facebook/Campaigns'
import Pixels from '../../../facebook/Pixels'
import Adsets from '../../../facebook/Adsets'
import Ads from '../../../facebook/Ads'
import Preview from '../../../facebook/Preview'
import Adcreatives from '../../../facebook/Adcreatives'

export default {
  fetchCampaigns ({ commit, dispatch }) {
    dispatch('startSpinner')
    commit(CLEAR_CAMPAIGNS_STATE)
    let user = helpers.getCurrentUser()
    const startDate = moment().subtract(1, 'month').format('YYYY-MM-DD')
    const endDate = moment().format('YYYY-MM-DD')
    let pixels = new Pixels(user)
    new Promise(resolve => {
      resolve(pixels.getAccountPixels())
    })
      .then(res => store.commit('auth/SET_ACCOUNT_PIXELS', res))
      .catch(err => {
        console.log(err.message)
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
    let campaigns = new Campaigns(user)
    return new Promise(resolve => {
      resolve(campaigns.fetchCampaigns())
    })
      .then(res => {
        commit(FETCH_CAMPAIGNS, res)
        res.forEach(campaign => {
          dispatch('startSpinner')
          campaigns = new Campaigns(user, {campaign, startDate, endDate})
          campaigns.fetchCampaignAdsets()
            .then(res => {
              if (!res.length) {
                campaign.targeting = null
                commit(EDIT_CAMPAIGN, campaign)
              }
              campaign.issues = []
              let targeting = null
              res.forEach((issue, index) => {
                if (index === 0) {
                  campaign.targeting = lodash.cloneDeep(issue.targeting)
                  targeting = lodash.cloneDeep(issue.targeting)
                } else {
                  if (!lodash.isEqual(targeting, issue.targeting)) campaign.targeting = null
                }
                let newIssue = issue._data
                campaign.issues.push(newIssue)
                commit(EDIT_CAMPAIGN, campaign)
                const adset = new Adsets(user, {adsetId: newIssue.id, startDate, endDate})
                new Promise(resolve => {
                  resolve(adset.fetchAdsetInsignts())
                })
                  .then(res => {
                    // if (res.adset_name) commit(ADD_INSIGHT_TO_ADSET, res)
                    dispatch('stopSpinner')
                })
              })
            })
            .catch(err => {
              const error = JSON.parse(err.message)
              const response = error.response || {}
              let identifier
              if (response.error_subcode) identifier = response.error_subcode
              else if (response.message) identifier = response.message
              helpers.handleError(error, identifier, 'Facebook: ')
            })
          // campaigns.fetchCampaignAds()
          //   .then(res => {
          //     campaign.messages = []
          //     res.forEach(message => {
          //       let newMessage = message._data
          //       const ads = new Ads(user, {adId: newMessage.id, startDate, endDate})
          //       new Promise(resolve => {
          //         resolve(ads.getAdById())
          //       })
          //         .then(res => {
          //           const message = Object.assign(res, {
          //             message_name: newMessage.name,
          //             id: newMessage.id,
          //             adcreative_id: res.id,
          //             adset_id: newMessage.adset_id
          //           })
          //           campaign.messages.push(helpers.convertFacebookAdFormat(message))
          //           commit(EDIT_CAMPAIGN, campaign)
          //           return ads.fetchAdInsignts()
          //         })
          //         .then(res => {
          //           // if (res.ad_name) commit(ADD_INSIGHT_TO_AD, res)
          //           dispatch('stopSpinner')
          //       })
          //     })
          //   })
          //   .catch(err => {
          //     const error = JSON.parse(err.message)
          //     const response = error.response || {}
          //     let identifier
          //     if (response.error_subcode) identifier = response.error_subcode
          //     else if (response.message) identifier = response.message
          //     helpers.handleError(error, identifier, 'Facebook: ')
          //   })
          campaigns.fetchCampaignInsights()
            .then(res => {
              // if (res.campaign_name) commit(ADD_INSIGHT_TO_CAMPAIGN, res)
              dispatch('stopSpinner')
            })
            .catch(err => {
              const error = JSON.parse(err.message)
              const response = error.response || {}
              let identifier
              if (response.error_subcode) identifier = response.error_subcode
              else if (response.message) identifier = response.message
              helpers.handleError(error, identifier, 'Facebook: ')
            })
        })
    })
      .catch(err => {
          console.log(err)
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  createCampaign ({ commit, dispatch }, payload) {
    dispatch('startSpinner')
    let user = helpers.getCurrentUser()
    let facebook = new Campaigns(user, {campaign: payload})
    const selectedAdvertiserId = user.firebaseAccount.selectedAdvertiser
    const advertiser = store.getters.getAdvertisers.find(a => a.id === selectedAdvertiserId)
    // Note: create new campaign
    return new Promise((resolve, reject) => {
      resolve(facebook.createCampaign())
    })
      .then(res => {
        commit(CREATE_CAMPAIGN, Object.assign(payload, {id: res.id, adlabels: res.adlabels, effective_status: 'PAUSED'}))
        if (!payload.issues.length) {
          dispatch('stopSpinner')
          commit('messages/CLEAR_MESSAGES_STATE')
        }
        // Note: create adsets
        payload.issues.forEach(issue => {
          dispatch('startSpinner')
          const params = {
            targeting: payload.targeting,
            start_time: payload.start_time,
            end_time: payload.end_time,
            adSetName: issue.name,
            campaignId: res.id,
            pageId: advertiser.data.fb_page_id,
            pixelId: payload.messages[0] ? payload.messages[0].selectedPixel : null
          }
          facebook = new Adsets(user, params)
          return new Promise(resolve => {
            resolve(facebook.createAdset())
          })
            .then(res => {
              const adsetId = res.id
              // Note: create messages
              if (!payload.messages.length) {
                dispatch('stopSpinner')
                commit('messages/CLEAR_MESSAGES_STATE')
              }
              const messages = payload.messages.filter(m => m.issue === issue.name)
              messages.forEach(message => {
                dispatch('startSpinner')
                // Note: if message has image, upload image to facebook
                if (message.file) {
                  const params = {
                    file: message.file
                  }
                  facebook = new Preview(user, params)
                  return new Promise((resolve, reject) => {
                    resolve(facebook.addImage())
                  })
                    .then(res => {
                      // Note: create ad creative
                      const params = {
                        description: message.description,
                        link: message.url,
                        image_url: res.url,
                        caption: message.displayLink,
                        message: message.text,
                        name: message.headline,
                        callToAction: message.callToAction.split(' ').join('_'),
                        pageId: advertiser.data.fb_page_id,
                        political: message.political ? 'POLITICAL' : '',
                        url_tags: message.urlParams,
                        video: message.selectedVideo
                      }
                      facebook = new Adcreatives(user, params)
                      return new Promise((resolve, reject) => {
                        resolve(facebook.createAdCreative())
                      })
                        .then(res => {
                          // Note: create new message
                          const adCreativeId = res.id
                          const params = {
                            name: message.name,
                            adsetId,
                            adCreativeId,
                            pageId: advertiser.data.fb_page_id,
                            pixelId: message.selectedPixel
                          }
                          facebook = new Ads(user, params)
                          return new Promise((resolve, reject) => {
                            resolve(facebook.createAd())
                          })
                            .then(res => {
                              dispatch('stopSpinner')
                              commit('messages/CLEAR_MESSAGES_STATE')
                            })
                            .catch(err => {
                              const error = JSON.parse(err.message)
                              const response = error.response || {}
                              let identifier
                              if (response.error_subcode) identifier = response.error_subcode
                              else if (response.message) identifier = response.message
                              helpers.handleError(error, identifier, 'Facebook: ')
                            })
                        .catch(err => {
                          const error = JSON.parse(err.message)
                          const response = error.response || {}
                          let identifier
                          if (response.error_subcode) identifier = response.error_subcode
                          else if (response.message) identifier = response.message
                          helpers.handleError(error, identifier, 'Facebook: ')
                        })
                      })
                        .catch(err => {
                          const error = JSON.parse(err.message)
                          const response = error.response || {}
                          let identifier
                          if (response.error_subcode) identifier = response.error_subcode
                          else if (response.message) identifier = response.message
                          helpers.handleError(error, identifier, 'Facebook: ')
                        })
                    })
                    .catch(err => {
                      const error = JSON.parse(err.message)
                      const response = error.response || {}
                      let identifier
                      if (response.error_subcode) identifier = response.error_subcode
                      else if (response.message) identifier = response.message
                      helpers.handleError(error, identifier, 'Facebook: ')
                    })
                } else {
                  // Note: create ad creative
                  const params = {
                    description: message.description,
                    link: message.url,
                    image_url: message.externalUrl || 'https://app.outfox.ai/static/img/of-logo.ba20680.png',
                    caption: message.displayLink,
                    message: message.text,
                    name: message.headline,
                    callToAction: message.callToAction.split(' ').join('_'),
                    pageId: advertiser.data.fb_page_id,
                    political: message.political ? 'POLITICAL' : '',
                    url_tags: message.urlParams,
                    video: message.selectedVideo
                  }
                  facebook = new Adcreatives(user, params)
                  return new Promise((resolve, reject) => {
                    resolve(facebook.createAdCreative())
                  })
                    .then(res => {
                      // Note: create new message
                      const adCreativeId = res.id
                      const params = {
                        name: message.name,
                        adsetId,
                        adCreativeId,
                        pageId: advertiser.data.fb_page_id,
                        pixelId: message.selectedPixel
                      }
                      facebook = new Ads(user, params)
                      return new Promise((resolve, reject) => {
                        resolve(facebook.createAd())
                      })
                        .then(res => {
                          dispatch('stopSpinner')
                          commit('messages/CLEAR_MESSAGES_STATE')
                        })
                        .catch(err => {
                          const error = JSON.parse(err.message)
                          const response = error.response || {}
                          let identifier
                          if (response.error_subcode) identifier = response.error_subcode
                          else if (response.message) identifier = response.message
                          helpers.handleError(error, identifier, 'Facebook: ')
                        })
                    })
                    .catch(err => {
                      const error = JSON.parse(err.message)
                      const response = error.response || {}
                      let identifier
                      if (response.error_subcode) identifier = response.error_subcode
                      else if (response.message) identifier = response.message
                      helpers.handleError(error, identifier, 'Facebook: ')
                    })
                }
              })
            .catch(err => {
              const error = JSON.parse(err.message)
              const response = error.response || {}
              let identifier
              if (response.error_subcode) identifier = response.error_subcode
              else if (response.message) identifier = response.message
              helpers.handleError(error, identifier, 'Facebook: ')
            })
            })
            .catch(err => {
              const error = JSON.parse(err.message)
              const response = error.response || {}
              let identifier
              if (response.error_subcode) identifier = response.error_subcode
              else if (response.message) identifier = response.message
              helpers.handleError(error, identifier, 'Facebook: ')
            })
        })
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  editCampaign ({ commit, dispatch }, payload) {
    let user = helpers.getCurrentUser()
    let facebook = new Campaigns(user, {campaign: payload})
    return new Promise((resolve, reject) => {
      resolve(facebook.editCampaign())
    })
      .then(res => {
        if (payload.status === 'ARCHIVED') {
          commit(DELETE_CAMPAIGN, payload.id)
        } else {
          commit(EDIT_CAMPAIGN, payload)
        }
        return true
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  updateInsights ({ state, commit, dispatch }, {startDate, endDate}) {
    // let user = helpers.getCurrentUser()
    // let facebook
    commit(CLEAR_CAMPAIGN_INSIGHTS)
    commit(CLEAR_ADSETS_INSIGHTS)
    commit(CLEAR_ADS_INSIGHTS)
    // state.campaigns.forEach(campaign => {
    //   facebook = new Campaigns(user, {campaign, startDate, endDate})
    //   facebook.fetchCampaignInsights()
    //     .then(res => {
    //       if (res.campaign_name) commit(ADD_INSIGHT_TO_CAMPAIGN, res)
    //       dispatch('stopSpinner')
    //     })
    //     .catch(err => {
    //       const error = JSON.parse(err.message)
    //       const response = error.response || {}
    //       let identifier
    //       if (response.error_subcode) identifier = response.error_subcode
    //       else if (response.message) identifier = response.message
    //       helpers.handleError(error, identifier, 'Facebook: ')
    //     })
    //   if (campaign.issues) {
    //     campaign.issues.forEach(issue => {
    //       if (!issue.id) return false
    //       facebook = new Adsets(user, {adsetId: issue.id, startDate, endDate})
    //       facebook.fetchAdsetInsignts()
    //         .then(res => {
    //           if (res.adset_name) commit(ADD_INSIGHT_TO_ADSET, res)
    //           dispatch('stopSpinner')
    //         })
    //         .catch(err => {
    //           const error = JSON.parse(err.message)
    //           const response = error.response || {}
    //           let identifier
    //           if (response.error_subcode) identifier = response.error_subcode
    //           else if (response.message) identifier = response.message
    //           helpers.handleError(error, identifier, 'Facebook: ')
    //         })
    //     })
    //   }
    //   if (campaign.messages) {
    //     campaign.messages.forEach(message => {
    //       if (!message.id) return false
    //       facebook = new Ads(user, {adId: message.id, startDate, endDate})
    //       facebook.fetchAdInsignts()
    //         .then(res => {
    //           if (res.ad_name) commit(ADD_INSIGHT_TO_AD, res)
    //           dispatch('stopSpinner')
    //         })
    //         .catch(err => {
    //           const error = JSON.parse(err.message)
    //           const response = error.response || {}
    //           let identifier
    //           if (response.error_subcode) identifier = response.error_subcode
    //           else if (response.message) identifier = response.message
    //           helpers.handleError(error, identifier, 'Facebook: ')
    //         })
    //     })
    //   }
    // })
  }
}
